import { useRef, useState } from "react";

import Modal from "shared/Components/modal";
import { MobilePagination } from "shared/Components/mobilePagination";
import Loader from "shared/Components/loader";
import { JudgeListCard } from "./judgeListCard";
import { TrialDetailCard } from "./judgeDetailCard";

export const JudgeListMobileTable = ({
  judges,
  currentPage,
  totalPages,
  loading,
  error,

  handlePageChange,
}) => {
  const modalRef = useRef();
  const [selectedTrialIndex, setSelectedTrialIndex] = useState(null);

  const openModal = (e, trialIndex) => {
    e.stopPropagation();
    setSelectedTrialIndex(trialIndex);
    modalRef.current.openModal();
  };

  return (
    <div>
      {!loading && !error ? (
        <>
          {judges.length > 0 ? (
            <div className="mb-[60px]">
              {judges.map((judge, index) => {
                return (
                  <div className="result-card-box">
                    <JudgeListCard
                      judge={judge}
                      onViewMoreClick={(e) => openModal(e, index)}
                    />
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="flex justify-center mt-[40%]">
              <span className="font-semibold text-xl text-gray-900">
                No Records
              </span>
            </div>
          )}

          {totalPages > 1 ? (
            <MobilePagination
              currentPage={currentPage}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
            />
          ) : (
            ""
          )}
        </>
      ) : loading ? (
        <Loader stroke="text-gradient-500" />
      ) : (
        <span>{error?.message}</span>
      )}
      <Modal ref={modalRef}>
        {selectedTrialIndex !== null && (
          <TrialDetailCard judgeDetail={judges[selectedTrialIndex]} />
        )}
      </Modal>
    </div>
  );
};
